type DetailPageTitle = {
  title: string;
  categoryName: string;
};

const createTitleByCategoryName = ({ title, categoryName }: DetailPageTitle) => {
  if (!categoryName) return;

  const splitTitle = title.split(' ');

  const [month, , popular, keyword] = splitTitle;

  return `${month} ${categoryName} ${popular} ${keyword}`;
};

export default createTitleByCategoryName;
